'use client';

import { usePathname, useRouter } from 'next/navigation';
import { ReactNode, useEffect } from 'react';

import Loader from '@/components/ui/Loader';
import { useAuth } from '@/hooks/useAuth';

function AuthProvider({ children }: { children: ReactNode }) {
  const { isLogin, isInitialized } = useAuth();
  const pathname = usePathname();
  const router = useRouter();

  useEffect(() => {
    if (!isInitialized) return;
    const isProtectedRoute = pathname.startsWith('/chat/') && pathname !== '/chat';
    if (!isLogin && isProtectedRoute) {
      router.replace('/chat');
    }
  }, [isLogin, isInitialized, pathname, router]);

  if (!isInitialized) {
    return (
      <div className="flex h-full min-h-screen w-full items-center justify-center">
        <Loader />
      </div>
    );
  }

  return <>{children}</>;
}
export default AuthProvider;
